import * as React from 'react';
import { useAppSelector } from 'hooks';
import { ControlledSelect } from 'components';
import { selectAllClients } from 'store/clients';
import { useFormContext, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
const CampaignClient = ({
  isDisabled = false,
  ...props
}: {
  isDisabled?: boolean;
  [key: string]: any;
}): JSX.Element => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();
  const {
    field: { value: agencyValue },
  } = useController({
    name: 'mediaAgency',
    control,
  });

  const {
    field: { value: clientValue },
  } = useController({
    name: 'client',
    control,
  });

  const clients = useAppSelector(selectAllClients);

  const options = React.useMemo(() => {
    //if agencyValue not set OR editMode (isDisabled) then add all clients to the list
    if (!agencyValue || isDisabled)
      return clients
        .map(({ id, name }: { id: number; name: string }) => ({
          id,
          name,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    return clients
      ?.filter(client => client.mediaAgency === agencyValue)
      .map(({ id, name }: { id: number; name: string }) => ({
        id,
        name,
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [clients, agencyValue, isDisabled]);

  React.useEffect(() => {
    //if editMode (isDisabled) return, ignoring agencyValue dependency
    if (isDisabled) return;

    const exists = options.find(option => option.id === clientValue);
    if (!exists) setValue('client', null);
  }, [agencyValue, isDisabled]);

  return (
    <ControlledSelect
      name='client'
      label={t('campaign.client', 'Klient')}
      options={options}
      isFilterable
      showUnfilteredResults
      isDisabled={isDisabled}
      {...props}
    />
  );
};

CampaignClient.displayName = 'Campaign.client';

export { CampaignClient };
